import { ReactNode } from 'react';

interface GenericErrorProps {
  config: {
    errorButtonAction?: (() => void) | null;
    reloadCheckoutAfterErrorButtonAction?: boolean;
    closeAction: () => void;
    reloadCheckoutAfterClose?: boolean;
    checkoutUrl: string;
    contactUrl: string;
    title: string;
    body: ReactNode;
    errorButton?: boolean;
    errorButtonTitle?: string;
  };
}

const GenericError = ({ config }: GenericErrorProps) => {
  const {
    errorButtonAction = null,
    reloadCheckoutAfterErrorButtonAction = false,
    closeAction,
    reloadCheckoutAfterClose = false,
    checkoutUrl,
    contactUrl,
    title,
    body,
    errorButton = false,
    errorButtonTitle,
  } = config;

  const handleHrefChange = (href: string) => {
    window.location.href = href;
  };

  const handleErrorButtonAction = () => {
    if (errorButtonAction !== null && errorButtonAction !== undefined) {
      errorButtonAction();
      if (reloadCheckoutAfterErrorButtonAction) {
        handleHrefChange(checkoutUrl);
      }
    }
  };

  const removeModal = () => {
    closeAction();
    if (reloadCheckoutAfterClose) {
      handleHrefChange(checkoutUrl);
    }
  };

  return (
    <div className="generic-error-wrapper">
      <div className="generic-error">
        <h1>
          {title}
          <button
            type="button"
            className="pull-right btn-as-link"
            onClick={() => removeModal()}>
            Close <i className="icon-remove" />
          </button>
        </h1>
        <div className="body">
          {body}
          <div className="actions">
            {errorButton && (
              <button
                className="retry-payment"
                type="button"
                onClick={() => handleErrorButtonAction()}>
                {errorButtonTitle}
              </button>
            )}
            <button
              className="contact-us grey-button"
              type="button"
              onClick={() => handleHrefChange(contactUrl)}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenericError;
